export default class TrameSsEssai {
    constructor(data = {}) {
        this.id = -1;
        this.displayMobile = true;
        this.idSousEssai = data.id;
        this.ordreMobile = null;
        this.libelle = data.libelle + ' (' + data.code + ')';
    }
}
